import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExhibitionsComponent } from './exhibitions.component';
import { ExhibitionItemComponent } from './exhibition-item.component';

const routes: Routes = [
  {
    path: '',
    component: ExhibitionsComponent,
    data: {
      cmsCategory: 'exhibitions',
    },
  },
  {
    path: ':id',
    component: ExhibitionItemComponent,
    data: {
      cmsCategory: 'exhibitions',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExhibitionsRoutingModule {
}
